import React from "react";
import { Flex } from "theme-ui";

interface Props extends salProps {
  header: string;
  text?: string | JSX.Element;
  className?: string;
}

const HeaderTextBox = ({
  header,
  text,
  className,
  sal = "slide-up",
  duration = 800,
  delay = 150,
  easing = "easeInOutBack",
}: Props) => {
  return (
    <Flex
      as="section"
      className={className}
      data-sal={sal}
      data-sal-delay={delay}
      data-sal-duration={duration}
      data-sal-easing={easing}
      sx={{
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        pt: [4, null, null, "90px"],
        pb: [4, null, null, text ? "45px" : 0],
        px: 3,
      }}
    >
      <h2
        sx={{
          variant: "text.h1HeaderRegular",
          textAlign: "center",
        }}
        dangerouslySetInnerHTML={{ __html: header }}
      />
      {typeof text === "object" ? (
        text
      ) : (
        <p
          sx={{
            variant: "text.h2HeaderSemiBold",
            maxWidth: [585],
            textAlign: "center",
            pt: "16px",
          }}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      )}
    </Flex>
  );
};

export default HeaderTextBox;
